export class Battery {
  constructor(public readonly level: number, public readonly health: string) {}

  public getHealthTranslationKey(): string {
    return `library.user_card.devices.list.battery.health.${this.health}`;
  }
}
